import { TextField } from '@material-ui/core';
import React, { useCallback } from 'react';
import { useSelector } from 'react-redux';
import { ApplicationState } from '~/store';
import { Container } from './styles';

interface IProps {
  pageTitle?: string;
}

const HeaderPage: React.FC<IProps> = ({ pageTitle = 'pageTitle' }) => {
  const auth = useSelector<ApplicationState, any>(state => state.auth);

  const profile = useSelector<ApplicationState, any>(
    state => state.user.profile,
  );

  const renderHeader = useCallback(() => {
    return (
      <div className="login-information">
        <TextField
          id="country-company-header"
          disabled
          label="Controlador"
          value={`${auth.company?.company?.company_name}-${auth.company?.country?.country_name}`}
          variant="outlined"
          className="TextField-lgpd"
        />
        <TextField
          id="ID-usuario"
          disabled
          label="ID do usuário"
          value={profile?.sub ? profile?.sub.toUpperCase() : ''}
          variant="outlined"
          className="TextField-lgpd"
        />
      </div>
    );
  }, [auth.company, profile]);

  return (
    <Container>
      <div className="header">
        <h1>{pageTitle}</h1>

        {renderHeader()}
      </div>
    </Container>
  );
};

export default HeaderPage;
